module.exports = __webpack_public_path__ + "static/media/quote-end.6e997d78.svg";